const getViewAllCtaUrl = (type, title) => {
  const viewAllUrl =
    type === 'Commercial' && title === 'By Value'
      ? '/features/commercial-service-software'
      : type === 'Commercial' && title === 'By Features'
      ? '/features#commercial'
      : type === 'Residential' && title === 'By Value'
      ? '/features/field-service-management-software'
      : '/features#residential';

  return viewAllUrl;
};

export default getViewAllCtaUrl;
